import { Component } from '@angular/core';
import {UserService} from "../../services/user.service";

@Component({
	moduleId: module.id,
	selector: 'forgot-password',
	templateUrl: 'forgot-password.html'
})

export class ForgotPasswordComponent{
	email: string;
	loading: boolean = false;
	sendPasswordResetEmail(): void {
		var me = this;
		me.loading = true;
		this.userService.passwordResetEmail(this.email)
		.then(function(result){
      //no real need to do anything here I think? The user will probably
      //be checking their email now and clicking the link in there. The service
			//is handling notifying the user the request was successful
			me.loading = false;
		})
	}
	constructor(
			private userService: UserService
	) {}

}



// WEBPACK FOOTER //
// ./src/app/components/forgot-password/forgot-password.component.ts